/** @format */

import { Col, Row } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { Service } from './service';

import "./styles.scss"

const canOpen = (link) => typeof link === 'string' && link.trim() && !['null', 'undefined'].includes(link.trim().toLowerCase());

export default function BannerPromotionsV2(props) {
	const [isLoading, setLoading] = useState(true);
	const [banners, setBanners] = useState([]);
	const [module, setModule] = useState({});
	const numColWeb = props.numColWeb;
	const numColMobile = props.numColMobile;

	useEffect(() => {
		Promise.all([
			new Service().getTemplate({ template: props.template, location: props.location }),
			new Service().getModuleByTemplate({ template: props.template, query: props.location }),
		])
			.then(([templateResponse, moduleResponse]) => {
				console.log('templateresponse',templateResponse,'moduleResponse',moduleResponse)
				if (templateResponse.data.length > 0) {
					setBanners([...templateResponse.data]);
					setModule(moduleResponse.data);
					setLoading(false);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, [props.template, props.location]);

	if (isLoading) {
		return Fragment;
	}

	return (
		<>
			<h2 className="ph-home-title">{module?.title}</h2>
			<Row className='ph-row-banner-container'>
				{banners?.map((item, i) => {
					const image = <img className="ph-banner-image" src={item.image} alt={item.title || ''} />;
					const className = 'ph-banner-hitarea';
					return (
						<Col xs={numColMobile} sm={numColWeb} md={numColWeb} lg={numColWeb} xl={numColWeb} key={i} className='ph-col-banner-container'>
							{canOpen(item.link) ? (
								<a className={className} href={item.link.trim()} rel="noopener noreferrer">
									{image}
								</a>
							) : (
								<div className={className}>{image}</div>
							)}
						</Col>
					);
				})}
			</Row>
		</>
	);
}
